export enum FORMATS {
  PRICE = "price",
  PERCENTAGE = "percentage",
}
